/*
 * @Description: 租客（承租人）列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2021-12-17 15:50:29
 * @LastEditors: zhao - 🍉
 */

import React from 'react';
import { message, Button } from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import { postFrom, config, transterQuery } from '../../axios';
import { expireDate } from '../../axios/dictionaries';
import axios from 'axios';
import moment from 'moment';
import Detail from './components/Detail';
import { moneyAddComma, handleExportParams } from '../../utils';

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                mustPayDateStart: '', //起始日期
                mustPayDateEnd: '', //到期日期
                keyword: '',
                pageSize: 10,
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            tableTotalMny: 0, //表格总金额
            tableSelectedRows: [], //表格选中的行
            selectedRowKeys: [],
            showDetailModal: false, //显示详情
        }

    }

    componentDidMount() {
        this.handleSearch();
    }

    handleRangeDate = (e) => { //选中日期
        if (e === '') {
            this.superFormRef.props.form.setFieldsValue({ mustPayDateStart: undefined, mustPayDateEnd: undefined });
        } else if (e === 1) { //距离7天
            this.superFormRef.props.form.setFieldsValue({ mustPayDateStart: moment(), mustPayDateEnd: moment().add(7, 'days') });
        } else if (e === 2) { //距离3天
            this.superFormRef.props.form.setFieldsValue({ mustPayDateStart: moment(), mustPayDateEnd: moment().add(3, 'days') });
        } else if (e === 3) { //距离1天
            this.superFormRef.props.form.setFieldsValue({ mustPayDateStart: moment(), mustPayDateEnd: moment().add(1, 'days') });
        } else if (e === 4) { //今天
            this.superFormRef.props.form.setFieldsValue({ mustPayDateStart: moment(), mustPayDateEnd: moment() });
        } else if (e === 5) { //逾期
            this.superFormRef.props.form.setFieldsValue({ mustPayDateStart: undefined, mustPayDateEnd: moment().subtract(1, 'days') });
        }
    }

    handleSelectChange = (selectedRowKeys, selectedRows) => { //表格选中行
        this.setState({ selectedRowKeys : selectedRowKeys ,tableSelectedRows: selectedRows });
    }

    handleSearch = (values = {}) => { //表单搜索/分页

        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });
        delete data.notUsed;

        axios.all([
            postFrom({ url: config.API_bill_findBillRemindCount, data }), //统计
            postFrom({ url: config.API_bill_findBillRemindPageList, data }) //分页
        ]).then(axios.spread((totalRes, listRes) => {
            this.setState({ tableTotalMny: totalRes.billTotalMoney, tableTotal: totalRes.billTotalNum, current: listRes.current, tableData: listRes.records, tableLoading: false });
            this.handleSelectChange([],[]);
        })).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleSendMessage = (e, id) => { //发送短信
        let data = {};
        if (id) { //发送单条
            data = { billId: id };
        } else { //批量发送
            let billId = this.state.tableSelectedRows.map((item) => item.id);
            data = { billId: billId.join(',') };
        }
        postFrom({ url: config.API_bill_billSmsSendNotice, data }).then(res => {
            message.success('发送成功');
            this.handleSearch();
        }).catch(err => {
            message.error(err.message || '发送失败');
        });
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            tableTotalMny,
            tableSelectedRows,
            showDetailModal,
            selectedRowKeys
        } = this.state;
        const rowSelection = {
            selectedRowKeys: selectedRowKeys,
            onChange: this.handleSelectChange,
        };
        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper search-wrapper-two" style={{ flexDirection: 'column', }}>
                    <SuperForm
                        onRef={ref => this.superFormRef = ref}
                        data={searchData({ handleRangeDate: this.handleRangeDate })}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                    <div className="search-btn-list">
                        <AuthButton authkey="a-1-2" type="primary" icon="export" href={`${config.API_bill_billExprotDate}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                            导出
                        </AuthButton>
                        <AuthButton authkey="a-1-3">
                            <Button  type="primary" disabled={!tableSelectedRows.length} icon="notification" onClick={this.handleSendMessage}>发送催收短信</Button>
                        </AuthButton>
                    </div>
                </div>
                <TableDOM
                    columns={columns({ handleSendMessage: this.handleSendMessage })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    totalMny={tableTotalMny}
                    current={current}
                    rowSelection={rowSelection}
                    onChange={this.handleSearch}
                />
                <Detail
                    onRef={ref => this.detailRef = ref}
                    visible={showDetailModal}
                    handleCancel={() => { this.setState({ showDetailModal: false }) }}
                />
            </PageWrap>
        )
    }

}

const searchData = ({ handleRangeDate }) => [
    {
        tagName: 'Select',
        formConfig: { name: 'notUsed' },
        attribute: { placeholder: '选择距离应付日', style: { width: '140px' }, onChange: handleRangeDate },
        optionData: [{ title: '全部', value: '' }].concat(expireDate),
        notResult: ''
    },
    {
        tagName: 'DatePicker',
        formItem: { label: '应收日期' },
        formConfig: { name: 'mustPayDateStart' },
        attribute: { placeholder: '请选择', style: { width: '110px' } },
    },
    {
        tagName: 'DatePickerEnd',
        formConfig: { name: 'mustPayDateEnd' },
        attribute: { placeholder: '请选择', style: { width: '110px' } },
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'keyword' },
        attribute: { placeholder: '输入关键字', style: { width: '160px' } },
        title: `在${handleExportParams().merchantId ? '' : '商户简称、'}项目名称、小区/楼栋、房号、租客名称、手机号码内模糊查询`
    },
];

const columns = ({ handleSendMessage }) => [
    {
        title: '应收日期',
        dataIndex: 'mustPayDate',
        render(text, record, index) {
            return <span>
                <div>{text ? moment(text).format('YYYY-MM-DD') : ''}</div>
                {record.overdueDays > 0 ? <div style={{ color: 'red' }}>逾期{record.overdueDays}天</div> : ''}
            </span>
        }
    },
    {
        title: '项目',
        dataIndex: 'projectName'
    },
    {
        title: '房源',
        dataIndex: 'buildingName',
        render(text, record, index) {
            return <span>
                <div>{text}</div>
                <div>{record.roomNo}</div>
            </span>
        }
    },
    {
        title: '租客',
        dataIndex: 'customerName',
        render(text, record, index) {
            return <span>
                <div>{text}</div>
                <div>{record.phone}</div>
            </span>
        }
    },
    {
        title: '费用',
        dataIndex: 'feeName'
    },
    {
        title: '账单期',
        dataIndex: 'billBeginDate',
        render(text, record, index) {
            return <span>
                <div>{text ? moment(text).format('YYYY-MM-DD') : ''}</div>
                <div>{record.billEndDate ? moment(record.billEndDate).format('YYYY-MM-DD') : ''}</div>
            </span>
        }
    },
    {
        title: '金额(元)',
        align: 'right',
        dataIndex: 'billMoney',
        render(text) {
            return moneyAddComma(text)
        }
    },
    {
        title: '商户',
        dataIndex: 'shortName'
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 150,
        render(text, record, index) {
            return <span>
                {record.smsLogStaus
                    ? <span style={{ color: '#d1d1d1' }}>今日已发送</span>
                    : <AuthButton authkey="a-1-3"><span className="showClickDetail" onClick={(e) => { handleSendMessage(e, record.id) }}>发送催收短信</span></AuthButton>}
            </span>
        }
    },
];


// WEBPACK FOOTER //
// ./src/page/Remind/Receiv.js